import { create } from "zustand";

/**
 * Store for canvas control callbacks (undo, zoom).
 * RampCanvasV2 registers its callbacks here, and ViewControlsPanel calls them.
 */
interface CanvasControlsState {
  /** Callback to undo the last action */
  onUndo: (() => void) | null;
  /** Callback to zoom in */
  onZoomIn: (() => void) | null;
  /** Callback to zoom out */
  onZoomOut: (() => void) | null;
  /** Current zoom level (for display purposes) */
  zoomLevel: number;

  // Actions
  registerCallbacks: (callbacks: {
    onUndo: () => void;
    onZoomIn: () => void;
    onZoomOut: () => void;
  }) => void;
  setZoomLevel: (level: number) => void;
  clearCallbacks: () => void;
}

export const useCanvasControlsStore = create<CanvasControlsState>((set) => ({
  onUndo: null,
  onZoomIn: null,
  onZoomOut: null,
  zoomLevel: 1,

  registerCallbacks: (callbacks) =>
    set({
      onUndo: callbacks.onUndo,
      onZoomIn: callbacks.onZoomIn,
      onZoomOut: callbacks.onZoomOut,
    }),

  setZoomLevel: (level) => set({ zoomLevel: level }),

  clearCallbacks: () =>
    set({
      onUndo: null,
      onZoomIn: null,
      onZoomOut: null,
    }),
}));
